import React, { createContext, useEffect, useRef, useState } from 'react'
import { Search } from 'react-bootstrap-icons';
import { apiAxios, download, downloadFile } from '../services/Api';
import Formulaire from './_recherche/Formulaire';
import Resultat from './_recherche/Resultat';
import { isEqual } from '../services/Fonctions';
import { logo } from '../pdf/Imges';

export const RechercheContext = createContext();

function Recherche() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const formulaireRef = useRef();


    const [onForm, setOnForm] = useState(true);
    const [submitedForm, setSubmitedForm] = useState({});

    const updateForm = (formData) => {
        if (isEqual(formData, submitedForm)) formulaireRef.current.rechercher();
        else setSubmitedForm(formData);
    }
    const [submitContext, setContext] = useState('');

    useEffect(() => {
        if (Object.keys(submitedForm).length) formulaireRef.current.rechercher();
    }, [submitedForm]);

    const goToPage = (page) => {
        recherche(page, submitContext);
    }

    const recherche = (page, context) => {
        let url = "api/recherche/" + context;
        if (page) {
            url = url + "?page=" + page;
        }
        if (submitedForm !== null && Object.keys(submitedForm).length) {
            setLoading(true);
            const fd = new FormData();

            for (const key in submitedForm) {
                if (submitedForm.hasOwnProperty(key)) {
                    fd.append(key, submitedForm[key]);
                }
            }
            apiAxios(url, fd).then(res => {
                if (res.data.length) {
                    setData(res);
                    setContext(context);
                    setOnForm(false);
                }
                else alert("Aucun resultat trouvez");
            }).finally(() => {
                setLoading(false);
            })
        }
        else {
            alert("Aucune donnée à envoyer")
        }
    }

    const exportExcel = () => {
        if (submitedForm !== null && Object.keys(submitedForm).length) {
            const params = submitedForm
            const form = document.createElement('form');
            form.setAttribute('target', '_blank');
            form.setAttribute('method', 'post');
            form.setAttribute('action', 'http://localhost:8000/api/excel/' + submitContext)

            for (const key in params) {
                if (params.hasOwnProperty(key)) {

                    const input = document.createElement('input');
                    input.type = "hidden"
                    input.name = key;
                    input.value = params[key];
                    form.appendChild(input);
                }
            }
            document.body.append(form);
            form.submit();
            //document.body.remove(form);
        }
        else {
            alert("Aucune donnée à envoyer")
        }
    }

    return (
        <>
            <RechercheContext.Provider value={{ setOnForm, updateForm, goToPage, exportExcel }}>
                <div className='d-flex justify-content-between mb-2'>
                    <div></div>
                    <div className='text-center'><img src={logo} width={200} /></div>
                    <div><button className='btn btn-primary' onClick={evt => setOnForm(!onForm)}><Search /></button></div>
                </div>
                <Formulaire display={onForm} ref={formulaireRef} waiting={loading} onFormSubmit={updateForm} execute={recherche} />
                <Resultat display={!onForm} waiting={loading} context={submitContext} data={data} execute={recherche} goToForm={setOnForm} />
            </RechercheContext.Provider>
        </>
    )
}

export default Recherche
